(function($) {
    /**
     * @typedef {Object} NeighborOverlay
     * @property {Number} index
     * @property {Number} distance
     */


    $.Overlay = function () {
        this._component_name = 'overlay';
        this._events = {
            clicked: 'clicked',
            button_clicked: 'button_clicked',
            overlays_loaded: 'overlays_loaded',
            data_loaded: 'data_loaded',
            init_overlay: 'init_overlay',
            ready: 'ready'
        };
        this._overlays = [];
        this._meta = null;
        this.using_webgl = false;
         
        // events
        this._on_draw = this._on_draw.bind(this);
        this._init_overlays = this._init_overlays.bind(this);
        this._on_load_json_overlays = this._on_load_json_overlays.bind(this);
        this._btn_clicked = this._btn_clicked.bind(this);

        // イベントの設定
        // this._on(this._events.data_loaded, this._emit.bind(this, this._events.ready));
    };

    $.Component.create($.Overlay, {

        _init_: function(options) {
            this._parse_options(options);
            $.Component.call(this, $.Overlay);   
        },

        //　必要なデータの読み込みを確認する 
        _check_loaded: function() {
            for(var prop in this._loaded_data) {
                if (this._loaded_data[prop] == false) {
                    return false;
                }
            }

            if (!this._initialized) {
                this._initialized = true; 
                this._emit(this._events.data_loaded); 
            }
            return true;
        },

        _parse_options: function(options) { 
            this._options = options || {}; 

            this.tracker = this._options.tracker || null;
            this.viewers = this._options.viewers || this.parent.viewers || window.viewers || []; 
        
            this.button_id = this._options.btn_nearest_overlay_id || 'btnNearestOverlay';
            this.distance_id = this._options.txt_distance_id || 'txtDistance'; 
            this._default_classname = 'abdo-overlay highlight';
            this._categories_buttons_container = this._options.categories_buttons_container || '.buttons-container';
        
            if (typeof(this._options.categories_buttons_container) === 'string') {
                this._categories_buttons_container = document.querySelector(this._options.categories_buttons_container);
            }
        
            // offset factor
            // オーバーレイが近い位置だとoffset_factor×半径の距離を離す
            if (typeof(this._options.offset_factor) !== 'undefined') {
                this._offset_factor = this._options.offset_factor;
            }
            else {
                this._offset_factor = 0.5;
            }
        
            this._loaded_data = { overlay_buttons: false, overlay_data: false };
            this._initialized = false;
            
            this._min_size = this._options.min_size || 10.0 * window.devicePixelRatio; 

            this._max_size = this._options.max_size || 100.0;

            if (typeof(this._options.callback) === 'function') {
                this._on(this._events.ready, this._options.callback);
            }
            
            this._overlay_size = this._options.overlay_size || 0.01;

            if(typeof(this._options.buttons) !== 'undefined') {
                this._buttons_url = this._options.buttons.url || '';
                if (this._buttons_url) {
                    this._load_buttons();
                }
                this._buttons_element = this._options.buttons.element || '';
                this._buttons_callback = this._options.buttons.callback || null;
        
                if (typeof(this._buttons_element) === 'string') {
                    this._buttons_element = document.getElementById(this._buttons_element);
                } 
            }


            // k nearest overlays list button functionality
            var nearestOverlaysListButton = document.querySelector(".nearest-overlay-list");
            if (nearestOverlaysListButton) {
                nearestOverlaysListButton.addEventListener(
                    ABDOUtil.getClickHandler(nearestOverlaysListButton), this._on_nearest_overlay_list_button_click.bind(this, nearestOverlaysListButton));
            }
  
            // get webgl form suboptions or default to disabled
            var webgl = this._options.webgl || { enabled: false, debug: false };
            var webgl_enabled = false;
            if (webgl.enabled === true) {
                webgl_enabled = true;
            }

            if (webgl_enabled && ABDOUtil.supportsWebGL && typeof(THREE) !== "undefined") {
                this.using_webgl = true; 
            }
            else {
                // fallback to OSD Overlay
                this._on(this._events.overlays_loaded, this._init_overlays);

                if (typeof(this._options.overlays) !== 'undefined') {
                    // URLの場合
                    if (typeof(this._options.overlays) === 'string') {
                        ABDOUtil.getJSON(this._options.overlays, this._on_load_json_overlays);
                    }
                    // 配列の場合
                    else if (this._options.overlays) {
                        this._load_overlays_from_object(this._options.overlays);
                    }
                    
                } 
            } 
        },

        _is_url: function(string) {
            if (typeof(string) !== "string")  {
                return false; 
            }

            var url;
            try {
                url = new URL(string);
            } catch(_) {
                return false;
            }

            return url.protocol === "http:" || url.protocol === "https:";
        }, 

        _is_boolean_string: function(string) {
            if (typeof(string) !== "string")  {
                return false; 
            }

            return ["true", "false"].includes(string.toLowerCase());
        },
 
        autodetect_meta: function(overlays) {
            var meta = { fields: {  text_fields: [], image_fields: [], link_fields: [] } };

            var first_overlay = overlays[0];
            for (var key in first_overlay) {
                if (Object.hasOwnProperty.call(first_overlay, key)) {
                    var value = first_overlay[key];

                    if (this._is_url(value)) {
                        meta.fields.link_fields.push(key);
                    } 
                    else if (this._is_boolean_string(value)) {

                    }
                    else if (typeof(value) === "string") {
                        meta.fields.text_fields.push(key);
                    }
                }
            }

            return meta;
        },

        _load_overlays_from_object: function(overlays_obj) {
            // if empty do nothing
            if (!overlays_obj) {
                return;
            } 

            var overlays_array = [];
            if (Array.isArray(overlays_obj)) {
                overlays_array = overlays_obj;
            }
            else if (Array.isArray(overlays_obj.data)) {
                overlays_array = overlays_obj.data;
            }

            this._overlays = overlays_array;
            // if it has metadata build an array
            if (typeof(overlays_obj.meta) !== "undefined") {
                this._meta = overlays_obj.meta;
            }
            else {
                this._meta = this.autodetect_meta(this._overlays);
            }

            this._add_overlays_properties(overlays_array);
            this._loaded_data.overlay_data = true;

            

            this._check_loaded();
            this._emit(this._events.overlays_loaded);
        },
        
        _on_load_json_overlays: function(json_array) {
            this._load_overlays_from_object(json_array);
        },

        _has_fields: function(overlay) {
            // check fields in meta
            if (this._meta && this._meta.fields) {
                 return true;
            }

            // check fields inside array
            for(var prop in overlay) { 
                if (overlay.hasOwnProperty(prop) && 
                    Array.isArray(overlay[prop]) && /(.+)_fields/.exec(prop)) {
                        return true;
                }
            }

            return false;
        },

        _add_overlays_properties: function(overlays) {
            var i, overlay;
            for (i = 0; i < overlays.length; i++) {
                overlay = overlays[i];
                this._add_overlay_properties(overlay);
                overlay.id = 'overlay' + i; 
                
                // todo move to tip.js
                if (this._has_fields(overlay)) {
                    overlay.tip = 'tip' + i;
                }
            } 
        },

        _add_overlay_properties: function(overlay) {
            if (!("width" in overlay)) {
                overlay.width = this._overlay_size;
            }
            if (!("height" in overlay)) {
                overlay.height = this._overlay_size;
            }
            
            if (!("className" in overlay)) {
                overlay.className = this._default_classname;
            }

            if (overlay.evacuation_place) {
                overlay.className += ' evacuation-place';
            } 

            overlay.rotationMode = OpenSeadragon.OverlayRotationMode.NO_ROTATION;
        },

        _load_buttons: function() { 
            var xhr = new XMLHttpRequest();
            xhr.open('GET', this._buttons_url, true);
            xhr.addEventListener('load', this._on_load_buttons.bind(this, xhr, this._buttons_url)); 
            xhr.send(); 
        },

        _create_buttons_from_overlays: function() {
            var index, overlays_n = this._overlays.length;
            for (index = 0; index < overlays_n; index++) { 
                this._create_button_from_overlay(this._overlays[index]);
            }

            this._loaded_data.overlay_buttons = true;
            this._check_loaded();
        },

        _create_button_from_overlay: function(overlay_data) {
            var buttons = [];
 
            if (!("categories" in overlay_data)) {
                return buttons;
            }

            for (var cat_index = 0; cat_index < overlay_data.categories.length; cat_index++) {
                var category = overlay_data.categories[cat_index];
                var modal = this._get_category_modal(category);
                if (modal) {
                    var container = modal.querySelector('.overlay_buttons');

                    if (container) {
                        var button = this._create_overlay_button(overlay_data);
                        
                        container.appendChild(button);
                        this._assign_button_event(button);
        
                        buttons.push(button);
                    }
                }
            }

            return buttons;
        },

        /**
         * Obtains title field from meta or various sources:
         * 1. overlays metadata
         * 2. first ocurrence of common title fields: title, name, 名前, 場所, 場所名
         * 3. first text field
         * @returns {String|null}
         */
        get_title_field: function(meta, overlays) {
            if (!meta) {
                return null;
            }

            if (typeof(meta.title_field) !== "undefined") {
                return meta.title_field;
            } 
            else if (Array.isArray(overlays) && overlays.length > 0) {
                var possible_title_fields = ["title", "name", "名前", "場所", "場所名"];
                var i, possible_title_field;
                for(i = 0; i < possible_title_fields.length; i++) {
                    possible_title_field = possible_title_fields[i];
                    if (Object.hasOwnProperty.call(overlays[0], possible_title_field)) {
                        meta.title_field = possible_title_field;
                        return meta.title_field;
                    }
                } 
            }
            else if (Array.isArray(meta.fields.text_fields) && meta.fields.text_fields.length > 0) {
                meta.title_field = meta.fields.text_fields[0];
                return meta.title_field;
            }

            return null;
        },

        _create_overlay_button: function(overlay_data, index) {
            var button = document.createElement('button');
            button.classList.add("btn-overlay");
            button.classList.add("btn_style_1");
            button.classList.add("transition");
            button.classList.add("carousel-button");
            button.dataset.showtip = true;
            button.dataset.dismiss = 'modal';
            button.dataset.overlay = overlay_data.element.id;

            // try to get overlay title field, else use id as button text
            var title_field = this.get_title_field(this._meta, this._overlays);
            if (title_field) {
                button.dataset.langkey = overlay_data[title_field];
                button.innerHTML = overlay_data[title_field];
            } 
            else { 
                button.innerHTML =  overlay_data.element.id;
            }
            
            return button;
        },

        _get_category_modal: function(category) {
            var selector = '.buttons-modal[data-category="' + category + '"]';
            var modal_element = document.querySelector(selector);
            if (!modal_element) { 
                modal_element = document.querySelector('.buttons-modal');
                
                if (modal_element) {
                    modal_element = modal_element.cloneNode(true);

                    modal_element.dataset.category = category;
                    document.body.appendChild(modal_element);  

                    if (this._categories_buttons_container) {
                        var button = document.createElement('button');
                        button.classList.add('btn_style_1', 'transition', 'carousel-button', 'btn-overlay-category');
                        button.dataset.category = category;
                        button.dataset.langkey = category;
                        button.innerHTML = category;
                        
                        button.addEventListener(ABDOUtil.getClickHandler(button), function(evt){
                            jQuery(modal_element).modal();
                        }, false);
        
                        this._categories_buttons_container.prepend(button);
                    }
                }
            }

            return modal_element;
        },

        _assign_buttons_events: function(parent_element) { 
            var nodelist = parent_element.getElementsByClassName('btn-overlay');
            for (var index = 0; index < nodelist.length; index++) {
                var button = nodelist[index];
                
                this._assign_button_event(button);
            }
        },
        
        _assign_button_event: function(button) { 
            button.addEventListener(ABDOUtil.getClickHandler(button), this._btn_clicked);
        },

        _on_load_buttons: function(request, url) { 
             // ローカルだとrequest.status == 0
             if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                if (typeof(this._buttons_element) === 'object') {
                    this._buttons_element.innerHTML = request.responseText;

                    this._assign_buttons_events(this._buttons_element);

                    this._loaded_data.overlay_buttons = true;
                    this._check_loaded();

                    if (typeof(this._buttons_callback) === 'function') {
                        this._buttons_callback(this._buttons_element, request.responseText);
                    }

                    if (typeof(abdo_osd) !== "undefined") {
                        abdo_osd.addCache(url);
                    }
                }
            }
        },

        // _add_overlays_click_handlers: function() {
        //     var overlay_elements = document.getElementsByClassName('abdo-overlay');
        //     var self = this;
        //     for (var i = 0; i < overlay_elements.length; i++) {
        //         var element = overlay_elements[i];
        //         element.addEventListener(ABDOUtil.getClickHandler(element), function(evt) { 
        //             self.overlayClicked.call(self, evt, this);
        //         });
        //     }
        //     this._initialized = true;
        // }, 

        overlayClicked: function(overlay_element, evt) {
            var viewer = ABDOUtil.getViewer();
            var overlay_osd = viewer.getOverlayById(overlay_element.id); 
            
            if (this.tracker) {
                this.tracker.enableScroll(false);
            }

            this._emit(this._events.clicked, evt, overlay_element, overlay_osd);
            overlay_element.abdo_events.emit(this._events.clicked, evt, overlay_element, overlay_osd);
        },  

        _removeClass: function(element, css_class) {
            if (ABDOUtil.isIE) {
                element.setAttribute('class', element.getAttribute('class').replace(css_class, ' '));
            }
            else {
                element.classList.remove(css_class);
            }
        }, 

        _preventCanvasClickPropagation: function(element) {
            if (typeof(element.tracker) === 'undefined')  {
                var mouse_tracker = new OpenSeadragon.MouseTracker({
                    element: element,
                    clickHandler: function(evt){
                        if (typeof(evt.quick) !== "undefined") {
                            if (evt.quick) {
                                this.overlayClicked.call(this, element, evt);
                            }
                        }
                        else {
                            this.overlayClicked.call(this, element, evt);
                        }
                    }.bind(this)
                });
                element.tracker = mouse_tracker;
            } 
        },

        /**
         * Get the K nearest overlay neighbors (brute-force) of the (x,y) viewport position and  in the projected space
         * @param {Number} x Viewport x coordinate
         * @param {Number} y Viewport y coordinate
         * @param {Number} k Number of neighbors
         * @param {OpenSeadragon.Viewer} viewer  
         * @returns {Array<NeighborOverlay>} The list of the nearest k neighbors of overlay
         */
        _get_k_nearest_overlays: function(x, y, k, viewer) {
            if (typeof(viewer.abdo.localization) === "undefined") {
                return [];
            }

            if (typeof(k) === "undefined" || k < 1) {
                k = this._overlays.length;
            }

            var pt = new OpenSeadragon.Point(x,y);
            var localization = viewer.abdo.localization;
            var overlay_proj = localization.vp2proj(pt.x, pt.y);
            if (!overlay_proj) {
                return [];
            }
            
            var proj_pt = new OpenSeadragon.Point(overlay_proj[0], overlay_proj[1]);
            var k_nearest = []; 

            this._overlays.forEach(function(added_overlay, added_index) {  
                var added_overlay_proj = localization.vp2proj(added_overlay.x, added_overlay.y);
                if (!added_overlay_proj) {
                    return;
                }

                var added_overlay_proj_pt = new OpenSeadragon.Point(added_overlay_proj[0], added_overlay_proj[1]);
                var distance = proj_pt.distanceTo(added_overlay_proj_pt);
                if (distance < 0.00001) {
                    return;
                }

                k_nearest.push({
                    index: added_index, 
                    distance: distance
                });
            });

            k_nearest.sort(function(a,b) {
                return a.distance - b.distance;
            });

            return k_nearest.slice(0, k);
        }, 

        _get_nearest_overlay: function(viewer, overlay){
            var nearest_index = -1;
            var nearest_distance = Number.MAX_VALUE;
            viewer.currentOverlays.forEach(function(added_overlay, added_index) {
                var centers_distance = Math.pow(added_overlay.location.x - overlay.x, 2) + Math.pow(added_overlay.location.y - overlay.y, 2);
                // 大きさは同値である前提で距離を測っている
                // 形が違うと変更することになる
                var distance = centers_distance;
                
                if (distance < nearest_distance) {
                    nearest_distance = distance;
                    nearest_index = added_index;
                }
            });

            return {
                index: nearest_index, 
                distance: Math.sqrt(nearest_distance)
            };
        },

        /**
         * Generate a displacement by options.offset_factor if overlays overlap
         * @param {*} viewer 
         * @param {*} overlay 
         */
        _handle_offset_factor: function(viewer, overlay) { 
            if (this._offset_factor > 0.0)  { 
                var nearest_data = this._get_nearest_overlay(viewer, overlay);
                var overlay_radius = this._overlay_size / 2.0; 
                if (nearest_data.distances < overlay_radius) {
                    var nearest_overlay = viewer.currentOverlays[nearest_data.index];
                    var offsets = [- this._offset_factor*overlay_radius, this._offset_factor*overlay_radius];
                    if (overlay.x < nearest_overlay.location.x) {
                        offsets[0] *= -1;
                        offsets[1] *= -1;
                    }
                    
                    nearest_overlay.location.x += offsets[0];
                    overlay.x += offsets[1];

                    viewer.updateOverlay(nearest_overlay);
                }
            }
        },

        _get_transform: function(position, size) {
            var x = position.x - (size.x/2.0);
            var y = position.y - (size.y/2.0);
            var translation = 'translate(' + x.toFixed(0) + 'px, ' + y.toFixed(0) + 'px)';
            return translation;
        },

        _on_draw: function(position, size, element) { 
            ABDOUtil._resize_overlay(size, this._max_size);

            // set size to 1 and use CSS scale() later
            // if (!element.style.width) {
            //     element.style.width = '1px';
            // }
            // if (!element.style.height) {
            //     element.style.height = '1px';
            // }
            element.style.width = size.x.toFixed(0) + 'px';
            element.style.height = size.y.toFixed(0) + 'px';


            // top and left set to 0 to use CSS translate later
            if (!element.style.left) {
                element.style.left = '0px';
            }

            if (!element.style.top) {
                element.style.top = '0px';
            }   
            // var scale = 'scaleX(' + size.x + ') scaleY(' + size.y + ')';
            element.style.transform = this._get_transform(position, size);

            // element.style.left = position.x + 'px';
            // element.style.top = position.y + 'px';

            var min_size = Math.min.apply(this, [size.x, size.y]); 
            if (min_size < this._min_size) {
                element.classList.add('d-none');
            }
            else {
                element.classList.remove('d-none');
            }

            
            if (this.viewers) {
                // assume 1 viewer
                /** @type {OpenSeadragon.Viewer} */
                var viewer = this.viewers[0];
                var bounds = viewer.viewport.getBounds();
                var position_vp = viewer.viewport.pointFromPixel(position);
                
                if (bounds.containsPoint(position_vp)) {
                    element.classList.remove("d-none");
                }
                else {
                    element.classList.add("d-none");
                }
            }
            
        },
        
        _append_overlay: function(viewer, overlay) {
            // disabled now that overlays can have a maximum size in pixels
            // this._handle_offset_factor(viewer, overlay); 
            this._add_overlay_properties(overlay);

            if (typeof(overlay.element) === "undefined") {
                overlay.element = document.createElement('div');
                overlay.element.id = overlay.id;
                overlay.element.className = overlay.className;
                document.body.appendChild(overlay.element);
            }
            else {
                overlay.id = overlay.element.id;
            }

            overlay.onDraw = this._on_draw;

            viewer.addOverlay(overlay);

            var overlay_obj = viewer.getOverlayById(overlay.id);
            overlay_obj.viewer = viewer;

            var abdo = ABDOUtil.get_abdo(viewer);
            if (abdo) {
                if (typeof(abdo.overlays) === "undefined")  {
                    abdo.overlays = [];
                }

                // note: if removing overlay, it has to be removed also from this 
                abdo.overlays.push(overlay_obj);
            }

            return overlay_obj;
        },

        _init_overlays: function() { 
            for (var index = 0; index < this._overlays.length; index++) {
                this._add_overlay(this._overlays[index]); 
            }

            this._emit(this._events.ready);
        },

        _init_overlays_webgl: function() { 
            for (var index = 0; index < this._overlays.length; index++) {
                this._add_overlay(this._overlays[index]); 
            }

            this._emit(this._events.ready);
        },

        _add_overlay: function(overlay) { 
            if (!("added" in overlay)) {
                overlay.added = false;
            }
            
            // gets first viewer
            var viewer = ABDOUtil.getViewer();
            if (viewer && !overlay.added) {
                this._append_overlay(viewer, overlay);
                this._init_overlay_viewer(viewer, overlay);
                this._create_button_from_overlay(overlay);
                
                if ( !(overlay.element && overlay.element.tracker)) {
                    overlay.element.addEventListener(
                        ABDOUtil.getClickHandler(overlay.element), this.overlayClicked.bind(this, overlay.element));
                    // overlay.element.tracker.clickHandler = this.overlayClicked.bind(this, overlay.element);
                } 

                overlay.added = true;
            }
            
        },
       
        _init_overlay_viewer: function(viewer, overlay_prop) {
            var overlay = viewer.getOverlayById(overlay_prop.id || overlay_prop.element.id);
            var overlayElement = overlay.element;  
            overlayElement.abdo_events = {};
            Emitter(overlayElement.abdo_events);
            this._preventCanvasClickPropagation(overlayElement);

            this._emit(this._events.init_overlay, overlay, overlay_prop);
        },

        // _finish_init: function () {  
        //     this._add_overlays_click_handlers();
        //     this._emit(this._events.ready); 
        // },

        _btn_clicked: function(evt) {  
            var btn = evt.currentTarget;
            var viewer = ABDOUtil.getViewer(); 
            if (typeof(btn.dataset.overlay) !== 'undefined') { 
                var overlay = viewer.getOverlayById(btn.dataset.overlay);
                if (overlay != null) {
                    var rect = $.Overlay.getOverlayRect(overlay, 3);
                    viewer.viewport.fitBounds(rect, true);

                    if (this.parent.tracker) {
                        this.parent.tracker.enableScroll(false);
                    }

                    this._emit(this._events.button_clicked, evt, btn, overlay);
                }
            }  
        },
        
        _create_overlay_list_modal: function(){
            var overlay_modal_element = document.createElement("div");
            overlay_modal_element.classList.add("modal");
            // todo create the rest of the modal element

            return overlay_modal_element;
        },

        _get_overlay_list_modal: function() {
            var overlay_modal_element = document.querySelector("#overlayList");
            if (!overlay_modal_element) {
                overlay_modal_element = this._create_overlay_list_modal();
            }
            return overlay_modal_element;
        },

        /**
         * Fills the modal dialog with overlay data
         * @param {HTMLDivElement} modal 
         * @param {Array} nearest_overlays 
         * @param {Array} nearest_overlays_current_location 
         */
        _fill_overlay_list_modal: function(modal, nearest_overlays_pin, nearest_overlays_current_location) {
            var from_pin_table = modal.querySelector("table.from-pin");
            if (from_pin_table) {
                this._add_overlays_to_table(from_pin_table, nearest_overlays_pin);
            }  
            
            var from_location_table = modal.querySelector("table.from-current-location");
            if (from_location_table) {
                this._add_overlays_to_table(from_location_table, nearest_overlays_current_location); 
            }
        },

        /**
         * Add nearest overlays to table_element
         * @param {HTMLTableElement} table_element 
         * @param {Array} overlays_list 
         */
        _add_overlays_to_table: function(table_element, overlays_list) {
            // clear table
            var tbody = table_element.querySelector("tbody");
            tbody.innerHTML = "";


            // if overlays_list is valid and has information
            if (Array.isArray(overlays_list) && overlays_list.length > 0) {
                var title_field = this.get_title_field(this._meta, this._overlays); 

                var i, k_overlay;
                for(i = 0; i < overlays_list.length; i++) {
                    k_overlay = overlays_list[i];
                    
                    var overlay = this._overlays[k_overlay.index];

                    var row = tbody.insertRow();
                    var title_cell = row.insertCell();
                    var distance_cell = row.insertCell();

                    if (title_field) {
                        title_cell.innerText = overlay[title_field];
                        title_cell.dataset.langkey = overlay[title_field];
                    } 
                    else { 
                        button.innerHTML =  overlay_data.element.id;
                    } 
                    distance_cell.innerText = k_overlay.distance.toFixed(0) + "m"; 
                }
            }
        },

        _on_nearest_overlay_list_button_click: function(btn, evt) {
            var k = 10;
            if (typeof(btn.dataset.k) !== "undefined") {
                k = Number(btn.dataset.k);
            }
        
            // distance is measured in projected coordinates, it can be whatever viewer we have
            var first_viewer = this.viewers[0];
            var abdo = first_viewer.abdo;
            var nearest_k_pin = null;
            var nearest_k_current_location = null;
            
            // get nearest overlays to pin
            var pin_overlay = first_viewer.getOverlayById("pin-0");
            if (pin_overlay) {
                var x = pin_overlay.location.x;
                var y = pin_overlay.location.y;
                nearest_k_pin = this._get_k_nearest_overlays(x, y, k, first_viewer);
            }

            // get nearest overlays to current location
            if (abdo.location_overlay) {
                var location = abdo.location_overlay.location; 
                nearest_k_current_location = this._get_k_nearest_overlays(location.x, location.y, k, first_viewer);
            }
  
            var overlay_list_modal = this._get_overlay_list_modal();
            if (overlay_list_modal) {
                this._fill_overlay_list_modal(overlay_list_modal, nearest_k_pin, nearest_k_current_location);

                // update overlay list when GPS location us updated
                if (!this._overlay_list_ontracking) { 
                    
                    // every time we get GPS location update overlay list
                    this._overlay_list_ontracking = function(event){ 
                        var location = event.detail.location;
                        nearest_k_current_location = this._get_k_nearest_overlays(location.x, location.y, k, first_viewer);
                        this._fill_overlay_list_modal(overlay_list_modal, nearest_k_pin, nearest_k_current_location);

                        // fill pin-location distance
                        var pin_distance_element = overlay_list_modal.querySelector(".pin-distance");
                        if (pin_distance_element && abdo.location_overlay && abdo.localization) {
                            var pin_distance = abdo.localization.point_distance(pin_overlay.location, abdo.location_overlay.location);
                            pin_distance_element.innerText = pin_distance.toFixed(0) + 'm';
                        }


                    }.bind(this);
                    $.on("tracker_finished_tracking", this._overlay_list_ontracking); 


                    // when GPS location stops remove listener and clear table
                    if (this._overlay_list_ontrackingstopped) {
                        this._overlay_list_ontrackingstopped = function() {
                            $.off("tracker_finished_tracking", this._overlay_list_ontracking);
                            this._overlay_list_ontracking = null;

                            this._fill_overlay_list_modal(overlay_list_modal, nearest_k_pin, null);

                            // clear pin-location distance
                            var pin_distance_element = overlay_list_modal.querySelector(".pin-distance");
                            if (pin_distance_element) {
                                pin_distance_element.innerText = '';
                            }

                        }.bind(this);
                        $.on("tracker_location_icon_removed" ,this._overlay_list_ontrackingstopped);
                    }
                }
                
                jQuery(overlay_list_modal).modal("show");
            } 
        }
    }, $.OSD);
 
    $.Overlay.getOverlayRect = function(overlay, factor) {
        factor = factor || 5;
        var size = overlay.bounds.width;
        if (size < overlay.bounds.height) {
            size = overlay.bounds.height;
        }
        
        var x = overlay.bounds.x;
        var y = overlay.bounds.y;
        var offset = size*factor;

        return new OpenSeadragon.Rect(x - offset, y - offset, offset*2, offset*2);
    };
 
    //inherit from component
}(ABDOMap));

// // to avoid uglify deletion
// (function() { new ABDOMap.Overlay(); })();